import { render } from "./ProjectNavigation.vue?vue&type=template&id=40d362f2"
import script from "./ProjectNavigation.vue?vue&type=script&lang=js"
export * from "./ProjectNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__